import { Component, inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GloboDogValidators } from '../../globo-dog-validators';

@Component({
  selector: 'app-edit-email-dialog',
  templateUrl: './edit-email-dialog.component.html',
  styleUrl: './edit-email-dialog.component.scss',
})
export class EditEmailDialogComponent {
  readonly fb = inject(FormBuilder);
  readonly dialogData = inject<{
    oldEmail: string;
  }>(MAT_DIALOG_DATA);

  emailForm = this.fb.group({
    newEmail: [
      this.dialogData.oldEmail,
      [Validators.required, Validators.email],
    ],
  });

  constructor() {
    this.emailForm.controls.newEmail.addValidators(
      GloboDogValidators.stringNotEquals(this.dialogData.oldEmail)
    );
  }
}
